/* global budgetChangesRulesUrl budgetChangesRulesSaveUrl budgetChangesRecordingUrl budgetChangesMovementsUrl budgetChangesMovementsExportUrl budgetChangesUsersUrl budgetChangesMovementsCount budgetChangesReadOnly */

import React, { useState } from 'react';
import ReactDOM from 'react-dom';

import App from 'App';

import ContingenciesApprovalsTab from './ContingenciesApprovalsTab';
import MovementsTab from './MovementsTab';

import Tabs, { RenderStrategyOnVisit } from 'CommonComponents/Tabs';

export default function BudgetChangeManagementIndex(props) {
    const [movementsCount, setMovementsCount] = useState(props.movementsCount);

    // Only the open tab renders: the rules tab refetches its balances on mount, and
    // the ledger is not worth loading until it is looked at.
    const tabs = [
        {
            id: 'budget-changes-rules',
            title: $t('Contingencies & Approvals'),
            renderStrategy: RenderStrategyOnVisit,
            content: () => (
                <ContingenciesApprovalsTab
                    rulesUrl={props.rulesUrl}
                    saveUrl={props.saveUrl}
                    recordingUrl={props.recordingUrl}
                    usersUrl={props.usersUrl}
                    readOnly={props.readOnly}
                />
            ),
        },
        {
            id: 'budget-changes-movements',
            title: (
                <>
                    {$t('Movements')}
                    <span className="bc-count">{movementsCount}</span>
                </>
            ),
            renderStrategy: RenderStrategyOnVisit,
            content: () => (
                <MovementsTab movementsUrl={props.movementsUrl} exportUrl={props.exportUrl} rulesUrl={props.rulesUrl} onCountChange={setMovementsCount} />
            ),
        },
    ];

    // The page title comes from the layout's own title bar, so this component
    // renders none of its own.
    return <Tabs tabs={tabs} />;
}

if (document.getElementById('budgetChangeManagement')) {
    ReactDOM.render(
        <App>
            <BudgetChangeManagementIndex
                rulesUrl={budgetChangesRulesUrl}
                saveUrl={budgetChangesRulesSaveUrl}
                recordingUrl={budgetChangesRecordingUrl}
                movementsUrl={budgetChangesMovementsUrl}
                exportUrl={budgetChangesMovementsExportUrl}
                usersUrl={budgetChangesUsersUrl}
                movementsCount={budgetChangesMovementsCount}
                readOnly={budgetChangesReadOnly}
            />
        </App>,
        document.getElementById('budgetChangeManagement'),
    );
}
